/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Dropdown } from '@mairistem/composants';
import { Liste, ListeQueryContext } from '@mairistem/liste';

import type { TypeListePacs } from '@/enums';
import type { Pacs } from '@/types/Pacs';
import PacsListeTable from './PacsListeTable';

interface PacsListeProps {
  pacs?: Array<Pacs>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSearch?: any;
  onSort?: any;
  onExplored?: any;
  onExpanded?: any;
  state?: any;
  mode?: 'expander' | 'explorer';
  dashboard?: boolean;
  modal?: boolean;
  stats?: boolean;
  assistant?: boolean;
  projet?: boolean;
  toutPacs?: boolean;
  optionsStatut?: Array<{
    key: TypeListePacs;
    text: string;
    value: TypeListePacs;
  }>;
  'data-testid'?: string;
  onSelect?: (item: Partial<Pacs>) => void;
}

const PacsListe = (props: PacsListeProps) => {
  const {
    pacs,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    mode,
    dashboard,
    modal,
    stats,
    assistant,
    projet,
    toutPacs,
    optionsStatut,
    'data-testid': dataTestId = 'pacs-liste',
    onSelect,
    ...handlers
  } = props;

  const { filterQuery } = React.useContext(ListeQueryContext);

  const handleStatutChange = (
    _e: React.SyntheticEvent,
    { value }: { value?: unknown },
  ) => {
    const statuts = Array.isArray(value) ? value : [];
    filterQuery(statuts.length ? { typeListe: statuts.join(',') } : {});
  };

  const getTitre = () => {
    if (toutPacs) return 'Liste des PACS et projets';
    return `Liste des ${projet ? 'projets de PACS' : 'PACS'}`;
  };

  const getCibleRecherche = () => {
    if (toutPacs) return 'PACS ou un projet de PACS';
    return projet ? 'projet de PACS' : 'PACS';
  };

  return (
    <Liste
      title={!assistant && !dashboard ? getTitre() : ''}
      mode={mode}
      searchable
      search={{
        clearable: true,
        placeholder: `Saisissez le nom d'un des partenaires pour rechercher un ${getCibleRecherche()}...`,
      }}
      {...handlers}
    >
      {optionsStatut && (
        <Dropdown
          selection
          multiple
          clearable
          className="pacs-liste-filtre-statut"
          options={optionsStatut}
          placeholder="Tous les statuts"
          style={{ minWidth: '12em' }}
          data-testid={`${dataTestId}-filtre-statut`}
          onChange={handleStatutChange}
        />
      )}
      <Liste.Content>
        <PacsListeTable
          mode={mode}
          items={pacs}
          loading={loading}
          count={count}
          perPage={perPage}
          onLoad={onLoad}
          onSort={onSort}
          dashboard={dashboard}
          modal={modal}
          stats={stats}
          assistant={assistant}
          data-testid={dataTestId}
          onSelect={onSelect}
        />
      </Liste.Content>
    </Liste>
  );
};

export default PacsListe;
